import { BASE_URL } from "./constants";
import { authFetch } from "../../../api/api"; 
export const money = (value, currency) => {
  const n = Number(value || 0).toLocaleString("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const symbol = currency?.symbol || "";
  return symbol ? `${symbol} ${n}` : n;
};

export const getOrderId = (item) => {
  const order = item?.order;
  if (order && typeof order === "object") return order.id;
  return order ?? "";
};

export const getOrderCode = (order) =>
  order?.order_code || order?.code || order?.order_number || order?.number || "";

export const getClientId = (order) => {
  if (!order) return null;
  const nested = order.client;
  if (nested && typeof nested === "object") return nested.id ?? null;
  return order.client_id ?? nested ?? null;
};

export const getOurAllocations = (allocation) =>
  (allocation.our_allocations || []).map((item) => ({
    id: item.id,
    order: Number(getOrderId(item)),
    amount: String(item.amount),
    currency: item.currency ?? null,
    date: item.date || null,
    comment: item.comment || "",
  }));

export async function requestJson(url, options = {}) {
  const response = await authFetch(url, options);
  const text = await response.text();
  let data = null;
  if (text) {
    try { data = JSON.parse(text); } catch { data = text; }
  }
  if (!response.ok) {
    const message =
      data?.detail ||
      (typeof data === "object" ? JSON.stringify(data) : data) ||
      `Ошибка запроса: ${response.status}`;
    throw new Error(message);
  }
  return data;
}

export async function fetchAllPages(endpoint) {
  let url = endpoint;
  const results = [];
  const visited = new Set();
  while (url && !visited.has(url)) {
    visited.add(url);
    const data = await requestJson(url);
    if (Array.isArray(data)) { results.push(...data); break; }
    results.push(...(data.results || data.orders || []));
    if (!data.next) break;
    const next = new URL(data.next, `${BASE_URL}/`);
    url = `${BASE_URL}${next.pathname}${next.search}`;
  }
  return results;
}

export const emptyAddDraft = () => ({
  orderCode: "",
  amount: "",
  currency: "",
  date: "",
  account: "",
  comment: "",
  payment_agent: "",
  payment_status: "PENDING",
});